import { captureMessage, captureException, isInitialized } from '@sentry/vue';

export const sentEventSentry = ({ event, error, level, name, tags, fingerprint, extra }) => {
    if (!isInitialized()) return null;

    if (error instanceof Error) {
        error.name = event ? `${event}: ${error.name}` : error.name;

        captureException(error, {
            level: 'error',
            tags: {
                'app.service': name,
                ...tags,
            },
            fingerprint: fingerprint,
            extra: extra,
        });
    } else {
        captureMessage(event, {
            level: level,
            tags: {
                'app.service': name,
                ...tags,
            },
            fingerprint: fingerprint,
            extra: extra,
        });
    }
};
